import React from 'react'
import { Link} from "react-router-dom"
import { toast } from 'react-toastify';
import { CambiarEnglish } from '../pages/Home';
import TypeWriterEffect from 'react-typewriter-effect';

const Home = () => {
  
  return (
    <div className=' flex w-full h-screen justify-center flex items-center text-gray-300'>

        <div className=' xl:w-8/12 md:10/12 lg:w-10/12 m-auto '>
          <h1 className='text-emerald-300 text-lg'>Hello, my name is</h1>
          <div>
            <h4 className='md:text-7xl text-3xl sm:text-4xl mt-5'>Yeremi Araya.</h4>
            <div className='flex text-gray-400 mr-2 mt-4 text-xl xl:text-5xl 2xl:text-7xl'>
              <h4 className='mr-4'>I develop
             
              </h4>
              <TypeWriterEffect
               textStyle={{
                fontFamily: 'Red Hat Display',
                color: '#3F3D56',
              }}
              startDelay={2000}
              cursorColor="#3F3D56"
              multiText={[
                'sites web Fullstack',
                'aplicaciones mobiles',
                'sites web Fullstack',
                'applications mobiles',
                'sites web Fullstack',
                'applications mobiles',
                'sites web Fullstack',
                'applications mobiles',
                
              ]}
              multiTextDelay={1000}
              typeSpeed={30}/>
            </div>
            
          </div>
          <div className='mt-6'>
            <p className='text-gray-500'>I am a self-taught programmer, passionate about constantly <br/> learning and creating high quality and optimal solutions.<br/>
            I am currently looking for new challenges that help me <br/>to grow as a programmer</p>
          <div className='mt-6 border hover:bg-emerald-900 py-2 px-2 w-20 rounded border-emerald-300 border-2'>
            {/*<Link to="/" className='text-emerald-300'>Spanish</Link>*/}
            <CambiarEnglish cambio={'/'} title={'Spanish'} message={'La pagina ha cambiado a español'}/>
          </div>
          </div>
      </div> 
    </div>
  )
}

export default Home